import { FC } from "react";
import { useTranslation } from "react-i18next";

const SignageSpeechBubble: FC = () => {
  const { t } = useTranslation();
  return (
    <div className="relative flex flex-col items-center">
      <div className="rounded-xl border border-gray-200 bg-white px-3 py-2 shadow-md">
        <span className="whitespace-nowrap text-sm font-bold text-gray-800">{t("正面玄関")}</span>
      </div>
      {/* 吹き出し三角 */}
      <div
        className="h-0 w-0 border-l-[6px] border-r-[6px] border-t-[8px] border-l-transparent border-r-transparent border-t-white"
        style={{ filter: "drop-shadow(0 1px 0 #e5e7eb)" }}
      />
    </div>
  );
};

export default SignageSpeechBubble;
